// Globals
import { Navigate, Outlet, useLocation } from 'react-router-dom';

// Store
import { useAppState } from '@/store';

// Components
import { StyledSpinnerWrapper } from './ProtectedRouteStyles';
import { Spinner } from '@/ui';

// Models
import { ROUTES } from '@/models/router.model';

// Modules
import { selectIsAuthorized } from '@/modules/Auth';

const ProtectedRoute = ({ redirectPath = ROUTES.SIGN_IN }: { redirectPath?: ROUTES }) => {
  const isAuthorized = useAppState(selectIsAuthorized);
  const location = useLocation();

  /** Состояние сессии ещё не определено — интерфейс не показываем */
  if (isAuthorized === null) {
    return (
      <StyledSpinnerWrapper>
        <Spinner size="large" />
      </StyledSpinnerWrapper>
    );
  }

  if (!isAuthorized) {
    return <Navigate to={redirectPath} replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
